<template>
  <div class="relative flex items-start">
    <div class="absolute flex items-center h-5">
      <input
        :id="$id('basic-checkbox')"
        type="checkbox"
        v-bind="$attrs"
        v-on="inputListeners"
        :class="inputClass"
        class="form-checkbox h-4 w-4 text-gray-600 transition duration-150 ease-in-out"
      />
    </div>
    <div class="pl-7 text-sm leading-5">
      <label v-if="label" v-text="label" :for="$id('basic-checkbox')" :class="labelClass" />

      <p class="mt-2 text-gray-500" v-if="hint" v-text="hint" />
      <p class="mt-2 text-red-600" v-if="hasError" v-text="error[0]" />
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  model: {
    prop: "checked",
    event: "change"
  },

  props: {
    label: {
      required: false,
      type: String
    },
    labelClass: {
      default: "font-medium text-gray-700",
      type: String
    },
    hint: {
      required: false,
      type: String
    },
    inputClass: {
      required: false,
      type: String
    },
    error: {
      required: false,
      default: null
    }
  },

  computed: {
    inputListeners: function() {
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          change: event => {
            this.$emit("change", event.target.checked);
          }
        }
      );
    },
    hasError() {
      return !!this.error;
    }
  }
};
</script>